<template>
  <div class="container">
    <img src="../assets/login_data.png" alt="" />
    <div class="go-sys">
      <div class="title">物联网平台</div>
      <div class="button" @click="handleSysClick">进入系统</div>
    </div>
    <div class="beian">
      © Copyright
      <!-- <a href="http://www.bignbiot.com" target="_blank"> bignbiot.com</a> -->
      All rights reserved
      <a href="https://beian.miit.gov.cn/" target="_blank">
        蜀ICP备2021004323号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleSysClick() {
      window.open("http://zs.bignbiot.com/#/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-image: url("/src/assets/login_bg.png");
  > img {
    position: absolute;
    left: 300px;
    top: 50%;
    transform: translateY(-50%);
    width: 700px;
    height: auto;
  }
  .go-sys {
    position: absolute;
    right: 300px;
    top: 50%;
    transform: translateY(-50%);
    color: #409eff;
    width: 400px;
    height: 200px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    .title {
      font-size: 22px;
      font-weight: bold;
      padding: 10px 0;
      margin-top: 30px;
    }
    .button {
      color: #ffffff;
      margin: 30px;
      padding: 10px 0;
      background-color: #409eff;
      border-radius: 10px;
      cursor: pointer;
    }
  }
  .beian {
    position: fixed;
    z-index: 1000;
    bottom: 0;
    margin-bottom: 15px;
    text-align: center;
    width: 100%;
    color: #fff;
    a {
      color: #fff;
    }
  }
}
</style>
